import authFetch from './fetch';
import qs from 'qs';
import { getQueryParams, makeRequest } from 'src/fetch/utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

export const getRateZones = async (postalCode = '') => makeRequest(authFetch.get(`/api/RateZone${postalCode ? `?PostalCode=${postalCode}` : ''}`));
export const searchRateZones = async (search) => makeRequest(authFetch.get(`/api/RateZone?search=${search}`));
export const useGetRateZones = (config = {}) => useQuery(['rate-zones'], () => getRateZones(), { ...CacheConfig.forever, ...config });

export const getRateZonesLookup = async (params) => makeRequest(authFetch.get(`/api/RateZone/Lookup?search=${params}`));

export const getRateZonesPaginated = async (params) => {
  const query = params && Object.keys(params).length > 0 ? `?${qs.stringify(params, { indices: false })}` : '';
  return makeRequest(authFetch.get(`/api/RateZone/Paginated${query}`));
};
export const getRateZone = (id) => makeRequest(authFetch.get(`/api/RateZone/${id}`));

export const searchRateZone = (name, type, marketId) => makeRequest(authFetch.get(`/api/RateZone?marketId=${marketId}&type=${type}${ name ? `&search=${name}` : ''}`));

export const postRateZone = async (rateZone) => makeRequest(authFetch.put('/api/RateZone', rateZone));

export const getRateZoneTypes = async () => makeRequest(authFetch.get('/api/RateZone/RateZoneTypes'));

export const getRateZoneLocationTypes = async () => makeRequest(authFetch.get('/api/RateZone/RateZoneLocationTypes'));

export const deleteRateZone = async (id) => makeRequest(authFetch.delete(`/api/RateZone/${id}`));

export const restoreRateZone = async (id) => makeRequest(authFetch.patch(`/api/RateZone/${id}/restore`));

export const getRateZoneAudit = (id, params) => makeRequest(authFetch.get(`/api/RateZone/${id}/Audits${getQueryParams(params)}`));
export const getRateZoneAuditProperties = (id, params) => makeRequest(authFetch.get(`/api/RateZone/${id}/Audits/Properties${getQueryParams(params)}`));
export const getRateZoneAuditUsers = (id, params) => makeRequest(authFetch.get(`/api/RateZone/${id}/Audits/Users${getQueryParams(params)}`));